const { atom } = require("recoil");

export const myCheckinTemplateState = atom({
  key: "myCheckinTemplateState",
  default: []
});

export const previewCheckinTemplateState = atom({
  key: "previewCheckinTemplateState",
  default: {}
});

export const checkinTemplateListState = atom({
  key: "checkinTemplateListState",
  default: {
    loader: {
      myTemplate: false,
      teamTemplate: false,
      addSelectedTemplate: false
    },
    myTemplate: [],
    teamTemplate: []
  }
});

export const errorFromBELoadingState = atom({
  key: "errorFromBELoadingState",
  default: false
});
